import { get } from 'lodash';
import { useModuleName } from '../../../hooks';

export const useShowHeader = config => {
    const module = useModuleName();
    const showHeader = !get(config.routingMap, `${module}.hideHeader`, false);

    return showHeader;
};
